import { render, staticRenderFns } from "./RadialMenu.vue?vue&type=template&id=46406fc1&scoped=true&"
import script from "./QuickLogisticRadialMenu.js?vue&type=script&lang=js&"
export * from "./QuickLogisticRadialMenu.js?vue&type=script&lang=js&"
import style0 from "./QuickLogisticRadialMenu.css?vue&type=style&index=0&id=46406fc1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46406fc1",
  null
  
)

export default component.exports